module.exports = __webpack_public_path__ + "img/GLT-LOGISTICS-01.06ffafe3.svg";